import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

const BEISPIELE = {
  mieter: ['Heizung bleibt kalt?', 'Frage zu den Nebenkosten?', 'Wasserfleck an der Decke?', 'Frage zur Hausordnung?', 'Nachbar zu laut?', 'Schlüssel verloren?'],
  eigentuemer: ['Frage zur Abrechnung?', 'Mieter meldet einen Schaden?', 'Dokument gesucht?', 'Frage zum Wirtschaftsplan?', 'Mietausfall melden?', 'Frage zum Hausgeld?'],
};

const useTypewriter = (items, active) => {
  const [text, setText] = useState('');
  useEffect(() => {
    if (!active) return undefined;
    let i = 0, pos = 0, del = false, t;
    const step = () => {
      const w = items[i];
      pos = del ? pos - 1 : pos + 1;
      setText(w.slice(0, pos));
      let wait = del ? 28 : 55;
      if (!del && pos === w.length) { del = true; wait = 1700; }
      if (del && pos === 0) { del = false; i = (i + 1) % items.length; wait = 350; }
      t = setTimeout(step, wait);
    };
    t = setTimeout(step, 600);
    return () => clearTimeout(t);
  }, [items, active]);
  return text;
};

/** Kopfzeilen-Button „Sag's Sonja“ – führt direkt in den Chat (ohne Aufklapp-Fenster oder Einmal-Hinweis). */
export const SagsSonjaButton = ({ user }) => {
  const navigate = useNavigate();
  const typed = useTypewriter(BEISPIELE[user?.role] || BEISPIELE.eigentuemer, true);

  return (
    <div className="relative hidden md:block" data-testid="sags-sonja-wrap">
      <button
        type="button"
        data-testid="sags-sonja-button"
        onClick={() => navigate('/portal/ai-assistent')}
        title="Sag's Sonja – Ihr Anliegen in Sekunden loswerden"
        className="sonja-cta group relative flex items-center gap-2.5 pl-1.5 pr-4 py-1.5 rounded-full text-brand-navy shadow-md hover:shadow-[0_0_28px_rgba(232,168,56,0.55)] hover:-translate-y-px active:scale-[0.98] transition-[box-shadow,transform] duration-300"
      >
        <span className="relative flex-shrink-0 w-9 h-9">
          <img src="/sonja.jpg" alt="Sonja" className="w-9 h-9 rounded-full object-cover ring-2 ring-white shadow" />
          <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full bg-emerald-500 ring-2 ring-white">
            <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-75" />
          </span>
        </span>
        <span className="relative flex flex-col items-start leading-none">
          <span className="flex items-center gap-1 text-[13px] font-extrabold tracking-tight">
            Sag&rsquo;s Sonja <Sparkles className="w-3.5 h-3.5 text-brand-navy/70 group-hover:rotate-12 transition-transform" />
          </span>
          <span className="block w-[170px] overflow-hidden text-left text-[10.5px] font-medium text-brand-navy/75 h-[13px] mt-0.5 whitespace-nowrap" data-testid="sags-sonja-typewriter">
            {typed}<span className="inline-block w-px h-[11px] bg-brand-navy/60 align-middle ml-px animate-pulse" />
          </span>
        </span>
        {/* Sprechblasen-Zipfel */}
        <span aria-hidden className="sonja-cta-tail absolute left-[46px] -bottom-[5px] w-3 h-3 rotate-45 rounded-[2px]" />
      </button>
    </div>
  );
};

/** Kompakte Variante für die mobile Kopfzeile. */
export const SagsSonjaMobileIcon = () => {
  const navigate = useNavigate();
  return (
    <div className="relative hidden sm:block md:hidden">
      <button type="button" onClick={() => navigate('/portal/ai-assistent')} data-testid="sags-sonja-mobile-icon" title="Sag's Sonja" aria-label="Sag's Sonja"
        className="relative w-9 h-9 rounded-full ring-2 ring-brand-gold shadow-sm overflow-hidden active:scale-95 transition-transform block">
        <img src="/sonja.jpg" alt="" className="w-full h-full object-cover" />
        <span className="absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full bg-emerald-500 ring-2 ring-white" />
      </button>
    </div>
  );
};

export default SagsSonjaButton;
